import { gql } from '@apollo/client';

export const INDUSTRIES_QUERY = gql`
  query DefaultIndustries {
    defaultIndustries {
      __typename
      id
      databaseId
      name
    }
  }
`;

export const COMPANY_INDUSTRY_UPDATE_MUTATION = gql`
  mutation companyUpdate($input: CompanyUpdateInput!) {
    companyUpdate(input: $input) {
      company {
        industry {
          id
        }
      }
      errors {
        message
        error
      }
    }
  }
`;
